<template>
    <el-dialog custom-class="dialogForm" class="measDialog" append-to-body :visible.sync="visible" :before-close="handleClose" :close-on-click-modal="false" width="80%" :title="title">
        <el-scrollbar class="dialogContentScroll">
            <el-form :model="form" ref="form" :rules="rules">
                <div class="formItemBox mb-15">
                    <el-form-item label="账号昵称" prop="nickname">
                        <el-input v-model="form.nickname" maxlength="20" show-word-limit placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="登录账号" prop="loginname">
                        <el-input v-model="form.loginname" maxlength="10" show-word-limit placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="角色类型" prop="roletype">
                        <el-select v-model="form.roletype" clearable>
                            <el-option v-for="item in roletypeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="真实姓名" prop="name">
                        <el-input v-model="form.name" maxlength="10" show-word-limit placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="手机号码" prop="telno">
                        <el-input v-model="form.telno" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="校区权限" prop="campuscode">
                        <SelectPage v-if="visible" @changePageGetList="changePageGetList" @getSelectValue="getSelectValue" :list="campusList" :label="'name'" :value="'code'" :paginationOption="campusPage" :isMultiple="true" :listLoading="campusLoading" :initData="initData"></SelectPage>
                    </el-form-item>
                </div>
                <el-form-item label="所属标签" prop="label">
                    <div class="box">
                        <span class="box-tag ml-5" v-for="(item,index) in labelList" :key="index" v-show="labelList.length > 0">{{item}}
                            <i class="el-icon-close pointer" @click="deleteTags(index)"></i>
                        </span>
                        <el-input style="flex:1" class="ml-5 input" ref="input" v-model="label" @change="changeLabel" placeholder="请输入"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="说明" prop="memo">
                    <el-input v-model="form.memo" type="textarea" show-word-limit autosize maxlength="200" placeholder="请输入"></el-input>
                </el-form-item>
            </el-form>
        </el-scrollbar>
        <div slot="footer" style="text-align:right">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" :loading="isLoading" @click="saveAccountInfo">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { getCampusList } from '@/api/measApi/campusManage.js'
import SelectPage from '@/components/measComponents/selectPage/selectPage.vue'
import {
  getAccountDetails,
  saveAccountInfo
} from '@/api/measApi/systemManage.js'
export default {
  data() {
    return {
      visible: false,
      title: '新增账号',
      form: {
        campuscode: '',
        campusname: '',
        code: '',
        label: '',
        loginname: '',
        logourl: '',
        logourlid: '',
        memo: '',
        name: '',
        nickname: '',
        recentlogintime: '',
        roletype: '',
        roletypename: '',
        telno: ''
      },
      rules: {
        nickname: [
          { required: true, message: '请输入账号昵称', trigger: 'blur' }
        ],
        loginname: [
          { required: true, message: '请输入登录账号', trigger: 'blur' }
        ],
        roletype: [
          { required: true, message: '请选择角色类型', trigger: 'change' }
        ],
        name: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
        campuscode: [
          { required: true, message: '请选择校区权限', trigger: 'change' }
        ]
      },
      //   角色类型：1超级管理员、2校区操作员、11学员
      roletypeList: [
        {
          value: 1,
          label: '超级管理员'
        },
        {
          value: 2,
          label: '校区操作员'
        },
        {
          value: 11,
          label: '学员'
        }
      ],
      campusList: [],
      campusPage: {
        pagesize: 5,
        page: 1,
        total: 0
      },
      campusLoading: false,
      label: '',
      labelList: [],
      isLoading: false,
      orgForm: {},
      initData: []
    }
  },
  components: {
    SelectPage
  },
  methods: {
    handleOpen(code) {
      this.visible = true
      this.orgForm = JSON.parse(JSON.stringify(this.form))
      this.getCampusList()
      if (code) {
        this.title = '编辑账号'
        getAccountDetails({ code: code }).then(res => {
          if (res.code === '000') {
            this.form = res.data
            if (this.form.label) {
              this.labelList = this.form.label.split(',')
            }
            this.form.campuscode.split(',').map((item, index) => {
              this.initData.push({
                code: item,
                name: this.form.campusname.split(',')[index]
              })
            })
          }
        })
      } else {
        this.title = '新增账号'
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    // 获取校区列表
    getCampusList() {
      const params = {
        condition: {
          name: ''
        },
        page: this.campusPage.page,
        pagesize: this.campusPage.pagesize
      }
      this.campusLoading = true
      getCampusList(params).then(res => {
        if (res.code === '000') {
          this.campusList = res.data
          this.campusPage.total = res.pageinfo.rowcount
          this.campusLoading = false
        }
      })
    },
    changePageGetList(page) {
      this.campusPage.page = page
      this.getCampusList()
    },
    getSelectValue(args) {
      let name = []
      let code = []
      args.map(item => {
        name.push(item.name)
        code.push(item.code)
      })
      this.form.campuscode = code.join(',')
      this.form.campusname = name.join(',')
    },
    // enter创建tag
    changeLabel(value) {
      if (value) {
        this.labelList.push(value)
        this.label = ''
      }
    },
    // 删除tag
    deleteTags(index) {
      this.labelList.splice(index, 1)
    },
    saveAccountInfo() {
      this.$refs.form.validate(validate => {
        if (validate) {
          this.isLoading = true
          if (this.labelList && this.labelList.length > 0) {
            this.form.label = this.labelList.join(',')
          }
          saveAccountInfo(this.form).then(res => {
            if (res.code === '000') {
              this.$message.success(res.msg)
              this.$emit('saveSuccess')
              this.isLoading = false
              this.handleClose()
            }
          })
        }
      })
    },
    handleClose() {
      if (this.isLoading) {
        this.$message.warning('提交数据中，请稍等')
        return
      }
      this.visible = false
      this.form = this.orgForm
      this.label = ''
      this.initData = []
      this.labelList = []
      this.$refs.form.clearValidate()
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: flex;
  flex-wrap: wrap;
  &-tag {
    background: #f6f7fb;
    border-radius: 4px 4px 4px 4px;
    height: 24px;
    padding: 0px 10px;
    display: flex;
    align-items: center;
    color: #999999;
    font-size: 12px;
    margin-top: 6px;
    i {
      margin-left: 8px;
    }
  }
  .input {
    ::v-deep .el-input__inner {
      border: none;
      height: 32px !important;
    }
  }
}
</style>

